// Demo analytics stub. In production this dispatches GA4 / Google Ads events
// per handover/form-crm-event-spec.md — never pass personal data (name,
// phone, email, address) as an event property, and always include the
// shared lead id so events dedupe against the CRM record.

export type AnalyticsEventName =
  | 'cta_click'
  | 'nav_click'
  | 'call_click'
  | 'form_start'
  | 'validation_failure'
  | 'accepted_lead'
  | 'planner_completion'
  | 'guide_request'
  | 'gallery_open';

export function trackEvent(
  eventName: AnalyticsEventName,
  props: Record<string, string | number | boolean | undefined> = {}
): void {
  if (typeof window === 'undefined') return;
  // eslint-disable-next-line no-console
  console.info(`[MCF demo analytics] ${eventName}`, props);
}
